import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(1.02); }
`;

const fadeIn = keyframes`
  0% { 
    opacity: 0; 
    transform: scale(0.97) translateY(3px);
  }
  100% { 
    opacity: 1; 
    transform: scale(1) translateY(0);
  }
`;

const leafSway = keyframes`
  0%, 100% { 
    transform: rotate(0deg); 
  }
  25% { 
    transform: rotate(2deg); 
  }
  75% { 
    transform: rotate(-2deg); 
  }
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(350%); }
`;

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0e2b63;
  padding: 2rem;
  font-family: 'Montserrat', sans-serif;

  .maintenance-card {
    background-color: #FFFFFF;
    box-shadow: 0px 3px 20px #0000000D;
    border: 1px solid #ECECF3;
    border-radius: 8px;
    padding: 3rem;
    max-width: 32rem;
    width: 100%;
    text-align: center;
  }

  .logo-wrapper {
    margin-bottom: 2rem;
    
    img {
      max-height: 60px;
      height: auto;
      object-fit: contain;
    }
  }

  .plant-wrapper {
    width: 100%;
    max-width: 120px;
    height: 140px;
    margin: 0 auto 1.5rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .plant-icon {
    width: 100%;
    height: 100%;
    animation: ${fadeIn} 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);
  }

  .plant-icon .leaf {
    animation: ${leafSway} 4s ease-in-out infinite;
    transform-origin: center center;
  }

  .plant-icon .leaf-top {
    animation: ${leafSway} 3s ease-in-out infinite;
    transform-origin: center bottom;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #102A63;
    margin-bottom: 1rem;
    letter-spacing: 0.5px;
  }

  .subtitle {
    font-size: 1rem;
    color: #495057;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .message {
    font-size: 0.95rem;
    color: #6c757d;
    line-height: 1.5;
  }

  .progress-bar {
    margin-top: 2rem;
    height: 4px;
    background: #E9EBEE;
    border-radius: 4px;
    overflow: hidden;

    .progress-fill {
      height: 100%;
      width: 30%;
      background: #102A63;
      border-radius: 4px;
      animation: ${shimmer} 2s ease-in-out infinite;
    }
  }
`;
